import { __decorate, __metadata } from "tslib";
import { IsDateTimeGreaterThanOrEqual } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEnum, IsMilitaryTime, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { StoreItemsExposeGroup, WeekDaysEnum } from '../enum';
export class ReadItemSetMetadataCriteriaDayDto {
}
__decorate([
    ApiProperty({ enum: WeekDaysEnum }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsEnum(WeekDaysEnum, { always: true }),
    __metadata("design:type", String)
], ReadItemSetMetadataCriteriaDayDto.prototype, "day", void 0);
__decorate([
    ApiProperty({ type: () => String, example: '09:00' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    IsMilitaryTime({ always: true }),
    __metadata("design:type", String)
], ReadItemSetMetadataCriteriaDayDto.prototype, "from", void 0);
__decorate([
    ApiProperty({ type: () => String, example: '21:00' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    IsMilitaryTime({ always: true }),
    IsDateTimeGreaterThanOrEqual('from', { format: 'HH:mm' }, { always: true }),
    __metadata("design:type", String)
], ReadItemSetMetadataCriteriaDayDto.prototype, "to", void 0);
//# sourceMappingURL=ReadItemSetMetadataCriteriaDayDto.js.map